import audioCtx from './context';
import { writable } from 'svelte/store';
class VolumeController {
    constructor() {
        this._initGainNodeMaster = () => {
            this.gainNodeMaster = audioCtx.createGain();
            this.gainNodeMaster.connect(audioCtx.destination);
            this.gainNodeMaster.gain.value = 1;
        };
        this._initGainNodeBeat = () => {
            this.gainNodeBeat = audioCtx.createGain();
            this.gainNodeBeat.connect(this.gainNodeMaster);
            this.gainNodeBeat.gain.value = 1;
        };
        this._initGainNodeSample = () => {
            this.gainNodeSample = audioCtx.createGain();
            this.gainNodeSample.connect(this.gainNodeMaster);
            this.gainNodeSample.gain.value = 0.8;
        };
        this.changeVolumeMaster = (newVolume) => { this.gainNodeMaster.gain.value = newVolume; };
        this.changeVolumeBeat = (newVolume) => { this.gainNodeBeat.gain.value = newVolume; };
        this.changeVolumeSample = (newVolume) => { this.gainNodeSample.gain.value = newVolume; };
        this._initGainNodeMaster();
        this._initGainNodeBeat();
        this._initGainNodeSample();
    }
}
export const volumeController = writable(new VolumeController());
export default volumeController;
export { VolumeController };
